import { configs } from '@/configs'
import { signer } from '../app/(dashboard)/assinar/[id]/Template/Sign/useSign/useSignLocally/signer'
import { useEffect } from 'react'
import { getUserEmail } from '@/hooks/useAuth/zustand'

const enabled = true

function downloadTextFile(filename: string, text: string) {
  const element = document.createElement('a')
  element.setAttribute(
    'href',
    `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`,
  )
  element.setAttribute('download', filename)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

const replacer = (key: string, value: string) =>
  typeof value === 'undefined' ? null : value

const key = 'debugLog'

export const sessionLogs = {
  set: (value: string) => localStorage.setItem(key, value),
  remove: () => localStorage.removeItem(key),
  get: () => localStorage.getItem(key) || '[]',
  getJson: (limitLines: number) => {
    const json = JSON.parse(sessionLogs.get())

    return json.slice(-limitLines)
  },
  add: (value: any, type?: string) => {
    const currentObject = sessionLogs.getJson(19)
    const newObject = [
      ...currentObject,
      {
        datetime: new Date().toISOString(),
        type,
        value,
        meta: {
          appVersion: configs.VERSION,
          extensionVersion: signer.extensionVersion,
          softwareVersion: signer.softwareVersion,
          userEmail: getUserEmail(),
        },
      },
    ]
    sessionLogs.set(JSON.stringify(newObject, replacer))
  },
  download: () => {
    downloadTextFile(
      `portal-debug-${new Date().toISOString()}.txt`,
      JSON.stringify(sessionLogs.getJson(20), null, 2),
    )
  },
}

export function debugLog(message: any, type?: string) {
  if (!message) return
  if (!enabled) return

  if (typeof window !== 'undefined') {
    sessionLogs.add(message, type)
  }
  console.log(message)
}

export function WindowLoadedLogger() {
  function windowLoadedLog() {
    debugLog(
      { href: window.location.href, referrer: document.referrer },
      'window addEventListener load',
    )
  }

  useEffect(() => {
    window.addEventListener('load', windowLoadedLog)

    return () => {
      window.removeEventListener('load', windowLoadedLog)
    }
  }, [])

  return <></>
}

export const devLog = (message?: any, ...optionalParams: any[]) => {
  if (configs.IS_DEVELOPMENT) {
    console.log(message, ...optionalParams)
  }
}
